import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import ReviewOrderHistoryTable from "./ReviewOrderHistoryTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const ReviewOrderHistory = () => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    orderHistory: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/BulkAssignInfo/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          orderHistory: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <ReviewOrderHistoryTable data={dataObj.orderHistory} />
        </div>
      )}
    </>
  );
};

export default ReviewOrderHistory;
